import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import {
  HeaderThree,
  ServiceFive,
  CtaOne,
  ProcessThree,
  TestimonialOne,
  FooterTwo,
} from "../containers";

const Service = () => (
  <Fragment>
    <Seo
      title="Services - Tech Ayukta"
      description="Explore Tech Ayukta’s range of services including Web Development, UI/UX Design, IT Consulting, Cloud Solutions, and more to help your business grow."
      keywords="Tech Ayukta Services, Web Development, UI/UX Design, IT Consulting, Cloud Solutions, Software Development"
      canonical="https://www.techayukta.com/services"
    />

    <HeaderThree />
    <Breadcrumb
      pageName="Services"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceFive className="space-top space-extra-bottom" />
    <CtaOne className="space" />
    <ProcessThree className="space-top space-extra-bottom" />
    <TestimonialOne className="space-top space-extra-bottom" />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default Service;
